import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { Connect, PropsFromRedux } from './PartiesContainer';
import { CommonSection } from '../CommonSection';
import { searchConstants } from '../../../search-utils/searchConstants';
import { PartiesBlock } from './block/PartiesBlock';
import { getKeyFromParty } from './partiesUtils';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { UserContextType } from '../../../../user/user.types';
import { withUser } from '../../../../user/UserContext';
import styles from './search_filters_parties.module.scss';

type Props = PropsFromRedux & UserContextType & WithRestrictedModalProps;

export class RawParties extends React.Component<Props> {
  updateParty = (kind: 'plaintiff' | 'defendant') => (
    data: { name?: string; type?: string } | null | undefined,
  ) => {
    const {
      accessPremium,
      onUpdateParties,
      openRestrictedModal,
      parties,
    } = this.props;
    if (!accessPremium) {
      openRestrictedModal('faceted-item');
    } else {
      const newParties = { ...parties, [kind]: data };

      doctrineAnalytics('Search PartySelectorClicked', {
        party: getKeyFromParty(parties.plaintiff),
        other_party: getKeyFromParty(parties.defendant),
      });
      onUpdateParties(newParties);
    }
  };

  render() {
    const { parties } = this.props;

    return (
      <CommonSection title={searchConstants.filters.parties}>
        <>
          <PartiesBlock
            inputId="filter_input_party"
            model={parties.plaintiff}
            updateParty={this.updateParty('plaintiff')}
          />
          <div className={styles.parties}>
            <span className={styles.text}>
              <FormattedMessage id="search/components/parties/Parties.tsx/1" />
            </span>
          </div>
          <PartiesBlock
            inputId="filter_input_otherparty"
            model={parties.defendant}
            updateParty={this.updateParty('defendant')}
          />
        </>
      </CommonSection>
    );
  }
}

export const Parties = withUser(withRestrictedModal(Connect(RawParties)));
